import { createActorContext, useSelector } from '@xstate/react';
import type { ActorOptions, AnyActorLogic } from 'xstate';

export const createActorContextWithUseActor = <TLogic extends AnyActorLogic>(
  actorLogic: TLogic,
  actorOptions?: ActorOptions<TLogic>,
) => {
  const actorContext = createActorContext(actorLogic, actorOptions);

  return {
    ...actorContext,
    useActor() {
      const actorRef = actorContext.useActorRef();
      const snapshot = useSelector(
        actorRef,
        currentSnapshot => currentSnapshot,
      );

      return [snapshot, actorRef.send, actorRef] as const;
    },
  };
};
